import React from 'react';
import { arrayOf, bool, string } from 'prop-types';

const ErrorMessages = ({ errors, ...gather }) =>
  errors.map((error) => <ErrorMessage key={error} error={error} {...gather} />);

export default ErrorMessages;

ErrorMessages.propTypes = {
  errors: arrayOf(string),
  hideLabel: bool,
  label: string
};

ErrorMessages.defaultProps = {
  errors: [],
  hideLabel: false,
  label: ''
};

const ErrorMessage = ({ label, error, hideLabel }) => (
  <li key={error} className="help-block">
    {hideLabel ? error : `${label} ${error}`}
  </li>
);

ErrorMessage.propTypes = {
  error: string,
  label: string,
  hideLabel: bool
};

ErrorMessage.defaultProps = {
  label: '',
  error: '',
  hideLabel: false
};
